import { render, staticRenderFns } from "./ManageUsersSuper.vue?vue&type=template&id=b5d10a52&scoped=true"
import script from "./ManageUsersSuper.vue?vue&type=script&lang=js"
export * from "./ManageUsersSuper.vue?vue&type=script&lang=js"
import style0 from "./ManageUsersSuper.vue?vue&type=style&index=0&id=b5d10a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d10a52",
  null
  
)

export default component.exports